package com.neurobs.ccabserver.administrator.view

import com.neurobs.js.dom.ElementFactory._
import com.neurobs.js.dom.DOMViewElement._
import com.neurobs.js.view.{CheckBox, Form, TextBox}

case class CreateAccountView
(
	form: Form,
	email: TextBox,
	confirmEmail: TextBox,
	firstName: TextBox,
	lastName: TextBox,
	organization: TextBox,
	description: TextBox
)

object CreateAccountView {

	private val boxWidth = 20
	private val formWidth = 40

	private def makeText = makeTextInput(boxWidth)

	def apply(): CreateAccountView = {
		val email = makeText
		val confirmEmail = makeText
		val firstName = makeText
		val lastName = makeText
		val organization = makeText
		val description = makeText
		val form = makeForm(
			width = formWidth,
			title = "Create Account",
			description = "",
			elements = Array(
				("Email:", email),
				("Confirm email:", confirmEmail),
				("First name:", firstName),
				("Last name:", lastName),
				("Organization:", organization),
				("Account description:", description)
			),
			useCancel = true,
			submitCaption = "Create"
		)
		CreateAccountView(form = form, email = email, confirmEmail = confirmEmail, firstName = firstName, lastName = lastName, organization = organization, description = description)
	}
}